import { type ComponentType } from "react";

import { type Mode } from "@demo/constants/mode";
import ComposeExport from "@demo/features/compose/export/ComposeExport";
import DetectExport from "@demo/features/detect/export/DetectExport";

/**
 * Per-mode export components, mirroring `SURFACES` in `ModeSurface`. A full
 * `Record<Mode, …>` so adding a mode to `MODES` is a compile error until it
 * supplies an export entry. A mode with no export yet renders `null`
 * (e.g. `DetectExport`), which hides the Export button for that mode.
 *
 * This file is the single cross-mode aggregator and lives outside `features/**`,
 * so it is exempt from the mode-boundary lint (like `ModeSurface`).
 */
export const EXPORTS: Record<Mode, ComponentType> = {
  compose: ComposeExport,
  detect: DetectExport,
};
